<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal
      [title]="
        variant() === 'transfer-to-nj' ? t('modalsNewServicingLoanTransferTitle') : t('modalsNewServicingLoanTitle')
      "
      [showCloseButton]="false"
      [closeOnBackdropClick]="false"
      [ariaLabelledBy]="'new-servicing-loan-modal-title'"
      (closeModal)="onContinue()"
    >
      <div modal-content>
        <div class="flex items-start gap-4">
          <div id="new-servicing-loan-icon" class="flex h-10 w-10 shrink-0 items-center justify-center">
            <mat-icon class="text-ld-link! text-xl!">info_outline</mat-icon>
          </div>

          <div class="flex flex-col gap-3">
            @if (variant() === 'transfer-to-nj') {
              <p id="new-servicing-loan-message" class="font-dm text-base text-ld-neutral-500 leading-relaxed">
                {{ t('modalsNewServicingLoanTransferMessage') }}
              </p>
            } @else {
              <p id="new-servicing-loan-message" class="font-dm text-base text-ld-neutral-500 leading-relaxed">
                {{ t('modalsNewServicingLoanMessage', { loanNumber: loanNumber() }) }}
              </p>
              <p id="new-servicing-loan-faq" class="font-dm text-base text-ld-neutral-500 leading-relaxed">
                {{ t('modalsNewServicingLoanFaqMessage') }}
                <a
                  id="new-servicing-loan-faq-link"
                  [routerLink]="faqLink()"
                  class="font-semibold text-ld-link hover:text-ld-link-hover"
                  (click)="onContinue()"
                >
                  {{ t('modalsNewServicingLoanFaqLink') }}
                </a>
                {{ t('modalsNewServicingLoanFaqMessageSuffix') }}
              </p>
            }
          </div>
        </div>
      </div>

      <div modal-footer>
        <button id="new-servicing-loan-continue-btn" type="button" class="btn-primary-ld-purple" (click)="onContinue()">
          {{ t('commonButtonsContinue') }}
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
